import React, { createContext, forwardRef, useContext, useId } from 'react';
import './editionFonts.css';

const SvgContext = createContext('');
export const ImageContext = createContext(null);
export function safeArtworkUrl(value) {
  if (typeof value !== 'string') return undefined;
  if (/^data:image\/(png|jpeg|webp);base64,[a-z0-9+/=]+$/i.test(value)) return value;
  if (/^\/(?!\/)/.test(value)) return value;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : undefined;
  } catch {
    return undefined;
  }
}
const scopeProps = (props, prefix) =>
  Object.fromEntries(
    Object.entries(props).map(([key, value]) => {
      if (key === 'id') return [key, `${prefix}-${value}`];
      if (typeof value === 'string' && value.includes('url(#'))
        return [key, value.replace(/url\(#([^)]*)\)/g, `url(#${prefix}-$1)`)];
      return [key, value];
    }),
  );
export default forwardRef(function Svg({ children, accessibilityLabel, ...props }, ref) {
  const id = useId().replace(/:/g, '');
  return (
    <SvgContext.Provider value={id}>
      <svg
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label={accessibilityLabel}
      >
        {children}
      </svg>
    </SvgContext.Provider>
  );
});
const element = (tag) =>
  forwardRef(function Primitive(props, ref) {
    const id = useContext(SvgContext);
    return React.createElement(tag, { ...scopeProps(props, id), ref });
  });
export const Defs = element('defs'),
  ClipPath = element('clipPath'),
  Circle = element('circle'),
  Filter = element('filter'),
  FeGaussianBlur = element('feGaussianBlur'),
  LinearGradient = element('linearGradient'),
  Stop = element('stop'),
  G = element('g'),
  Line = element('line'),
  Rect = element('rect');
export function Text(props) {
  const id = useContext(SvgContext);
  return (
    <text
      {...scopeProps(props, id)}
      fontFamily={Number(props.fontWeight) >= 600 ? 'EditionSemiBold' : 'EditionRegular'}
      fontWeight={400}
    />
  );
}
export function Image({ href, onLoad, ...props }) {
  const images = useContext(ImageContext);
  const value = images ? images[href] : href;
  const uri = safeArtworkUrl(value);
  if (!uri) return null;
  return (
    <image
      {...props}
      href={uri}
      onLoad={
        onLoad ? () => onLoad({ nativeEvent: { source: { width: 1, height: 1 } } }) : undefined
      }
    />
  );
}
